<div class="textRecordsContainer">
     <div class="loader" *ngIf="bodySpinner"></div>
    <div class="header hdr">
         <div class="row" id="emailTableSearch">
                <div class="col-3">
        <h5><span class="animateH5">Feedback</span></h5>
        </div>
        <div class="col px-0">
        </div>
        </div>
    </div>
    <div class="container-fluid">
            <div class="table-responsive">
                <div class="card tblCrd"> 
                  
                       <table class="table text-center">
                        <thead class="tblHead">
                            <tr>
        
                               <th class="text-start">Email</th>
                                 <th>Question</th>
                                 <th>Answer</th>
                                    <th>Source Doc</th> 
          
                                <th>Accurate</th>
                                 <th>Comments</th>
                                 <th>Created Date</th>
                            
                 
                            </tr>
                        </thead>
                        <tbody>
                            @if(feedbackListData.length > 0){
                               @for(items of feedbackListData | paginate :{itemsPerPage:limit,
                                currentPage:pageNo,
                                totalItems:total_records}; track items?.qid){
                                <tr>
                                    <td>{{items?.feedback_email}}</td>
                                    <td>{{items?.question}}</td>
                                    <td><p [innerHTML]="items?.answer"></p></td>
                                    <td>{{getSourcedoc_names(items?.source_paragraphs)}}</td>
                                    <td>{{items?.accurate}}</td>
                                    <td>{{items?.feedback}}</td>
                                    <td>{{items?.feedback_created_at | date:'MMM dd, YYYY h:mm a'}}</td>
                                </tr>
                               }
                            }@else{
                            <tr>
                                <td colspan="7" style="text-align: center;"> 
                                    <span *ngIf="!bodySpinner">No Records</span>
                                </td>
                            </tr>
                        }
                  
                         
                    </tbody>
                     </table>
                
                </div>
                </div>  
                 <div class="paginationRecords" *ngIf="feedbackListData.length > 0">
                    <div class="d-flex align-items-center">
                        <span class="col-md-6 pagination-records">
                            Showing {{feedbackListData.length}} of {{total_records}} records
                        </span>
                        <span class="col-md-6 pull-right">
                        
                                <pagination-controls #pagination [maxSize]="7" [responsive]="true" [autoHide]="true"
                                    [directionLinks]="true" (pageChange)="pageChanged($event)">

                                </pagination-controls>
                            
                        </span>
                    </div>
                </div>     
    </div>
 </div>
            